export const setContextParam = (_module, value) => {
  try {
    window.sessionStorage.setItem(`ga4${_module}Context`, value);
  } catch {
    // User disables it's sessionStorage. It's up to them to protect their privacy.
  }
};

export const getContextParam = (_module) => {
  try {
    return window.sessionStorage.getItem(`ga4${_module}Context`);
  } catch {
    // User disables it's sessionStorage. It's up to them to protect their privacy.
    return null;
  }
};
